/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesInviteEmailInviteResponse
 */
export interface FxIdWebFeaturesInviteEmailInviteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesInviteEmailInviteResponse
     */
    Success: boolean;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesInviteEmailInviteResponse
     */
    Error: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesInviteEmailInviteResponse
     */
    Token?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteResponse interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteResponse(value: object): value is FxIdWebFeaturesInviteEmailInviteResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Error' in value) || value['Error'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesInviteEmailInviteResponseFromJSON(json: any): FxIdWebFeaturesInviteEmailInviteResponse {
    return FxIdWebFeaturesInviteEmailInviteResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesInviteEmailInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesInviteEmailInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Error': json['Error'],
        'Token': json['Token'] == null ? undefined : json['Token'],
    };
}

export function FxIdWebFeaturesInviteEmailInviteResponseToJSON(json: any): FxIdWebFeaturesInviteEmailInviteResponse {
    return FxIdWebFeaturesInviteEmailInviteResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesInviteEmailInviteResponseToJSONTyped(value?: FxIdWebFeaturesInviteEmailInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Error': value['Error'],
        'Token': value['Token'],
    };
}

